import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { deleteSupplier } from '../../../action'
import { GlobalState } from '../../../GlobalState'
import Loading from '../../../util/Loading'
import { TabTitle } from '../../../util/titleChanger'
import { api } from '../../../util/urlConfig'
import ReactPaginate from 'react-paginate'
import { toast, ToastContainer } from 'react-toastify';

export default function SupplierDashboard() {
    TabTitle('Supplier Dashboard')
    const state = useContext(GlobalState)
    const [suppliers] = state.supplierAPI.suppliers;
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Local state
    const [rowPerPage] = state.supplierAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.supplierAPI.pageNumber;
    const [totalPages] = state.supplierAPI.totalPages;
    const [setSearch] = state.supplierAPI.search;
    const [callback, setCallback] = state.supplierAPI.callback;

    useEffect(() => { }, [rowPerPage, suppliers, pageNumber])

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const deleteSupplierHandler = (id) => {
        deleteSupplier(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }
    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Supplier Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search supplier here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/supplier-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    suppliers.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Avatar</th>
                                        <th>Supplier Code</th>
                                        <th>Supplier Name</th>
                                        <th>Contact No</th>
                                        <th>NIC</th>
                                        <th>Email</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        suppliers.count > 0 ? suppliers.data.map(supplier => (
                                            <tr key={supplier.id}>
                                                <td><img src={supplier.upload_image ? api + "/" + supplier.upload_image.image_url : '/img/dummy_avatar.png'} /></td>
                                                <td>{supplier.supplier_code}</td>
                                                <td>{supplier.first_name + " " + supplier.last_name}</td>
                                                <td>{supplier.contact_no}</td>
                                                <td>{supplier.nic}</td>
                                                <td>{supplier.email}</td>
                                                <td>
                                                    <Link to={`/supplier-form/${supplier.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to={`/supplier-view/${supplier.id}`}><button><i className="uil uil-eye"></i></button></Link>
                                                    <button onClick={() => deleteSupplierHandler(supplier.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan="7">Can not found any suppliers.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}